import './style/bolmateImageFallback.scss';

import {Icon} from '@iconify/react';

import classNames from 'classnames';

import React, {ReactNode, useState} from 'react';

import BolmateTooltip from '../tooltip/bolmateTooltip';

export type ImageBadgeColor = 'blue' | 'green' | 'red' | 'purple' | 'gray';

interface Props {
    src: string | null | undefined;
    alt?: string;
    fallbackIcon?: string;
    className?: string;
    imageClassName?: string;
    /** Overlay pinned to the image's top-right corner (e.g. a quantity badge). */
    badge?: ReactNode;
    /** Tooltip shown on hover of the badge (BolmateTooltip) — explains what it means. */
    badgeTitle?: string;
    /** Fill of the badge. Defaults to the Bolmate blue. */
    badgeColor?: ImageBadgeColor;
}

export default function BolmateImageFallback(props: Props) {
    const {
        src,
        alt = '',
        fallbackIcon = 'mdi:package-variant-closed',
        className,
        imageClassName,
        badge,
        badgeTitle,
        badgeColor = 'blue'
    } = props;
    const [error, setError] = useState(false);

    function onError() {
        setError(true);
    }

    function renderImage() {
        // Without a badge there is no container element, so the wrapper class
        // lands on the image/fallback itself instead of being dropped.
        if (src && !error) {
            return (
                <img
                    src={src}
                    alt={alt}
                    className={classNames('bolmate-image', imageClassName, badge == null && className)}
                    onError={onError}
                />
            );
        }
        return (
            <div className={classNames('bolmate-image-fallback', imageClassName, badge == null && className)}>
                <Icon icon={fallbackIcon} className='bolmate-image-fallback-icon' />
            </div>
        );
    }

    if (badge == null) return renderImage();
    const badgeNode = (
        <div className={classNames('bolmate-image-badge', badgeColor, {'has-title': badgeTitle != null})}>{badge}</div>
    );
    return (
        <div className={classNames('bolmate-image-container', className)}>
            {renderImage()}
            {badgeTitle != null ? (
                <BolmateTooltip text={badgeTitle} className='wrap'>
                    {badgeNode}
                </BolmateTooltip>
            ) : (
                badgeNode
            )}
        </div>
    );
}
